import { Content, NoticeStore, NoticeType } from 'feature/notice/NoticeStore'
import { i18n } from 'i18n'
import { makeAutoObservable } from 'mobx'

class NoticeController {
  notices: NoticeStore[] = []

  constructor() {
    makeAutoObservable(this)
  }

  info(content: Content): void {
    this.open('info', content)
  }

  success(content?: Content): void {
    content = content || i18n('Success')
    this.open('success', content)
  }

  error(content?: Content): void {
    content = content || i18n('Error')
    this.open('error', content)
  }

  remove(notice: NoticeStore) {
    const index = this.notices.indexOf(notice)
    if (index < 0) return
    this.notices.splice(index, 1)
  }

  private open(type: NoticeType, content: Content) {
    this.notices.push(new NoticeStore(type, content))
  }
}

export const notice = new NoticeController()
